// Route guard for the employee "My Products" page: renders it only when the tenant has
// ≥1 product enabled for the employee. A deep link when nothing is on redirects to the
// dashboard, so the page is never reachable while the nav item is hidden. Mirrors the
// nav gate in TenantAwareNavigationSidebar.
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useEntitlements } from '@/features/entitlements/useEntitlements';
import { useMarketplaceVisible } from './useMarketplaceVisible';
import MyProductsPage from './MyProductsPage';

export default function MyProductsRoute() {
  const { hasProduct } = useEntitlements();
  const hasCredit = hasProduct('credit');
  const { loaded, visible } = useMarketplaceVisible(hasCredit);

  if (!hasCredit) return <Navigate to=".." replace />;
  if (!loaded) return null; // brief: waiting on the visibility check
  if (!visible) return <Navigate to=".." replace />;
  return <MyProductsPage />;
}
